<script>
    import {DB} from "../../../firebase/db";
    import{ Notification } from 'element-ui';
    import { mapGetters } from 'vuex';

    export default {

        data() {
            return {
                form: {},
                submitting: false,
                submitted: false
            }
        },

        computed: {
            ...mapGetters( [
                'editApplicationModal',
                'activeApplication'
            ]),

            projectId() {
                return this.$route.params.project;
            }
        },

        watch: {
            activeApplication: {
                handler: function () {
                    this.form = this.activeApplication;
                }
            }
        },

        methods: {

            submit() {

                this.submitting = true;

                this.form.project_id = this.projectId;

                DB.collection('applications')
                    .doc(this.activeApplication.id)
                    .update(this.form)
                    .then( () => {
                        this.submitting = false;
                        this.closeDrawer();

                        Notification.success({
                            title: 'Success!'.toUpperCase(),
                            message: 'Application is updated successfully',
                            position: 'bottom-right'
                        });

                    }, () => {

                        this.submitting = false;
                        this.closeDrawer();

                        Notification.error({
                            title: 'Error!'.toUpperCase(),
                            message: 'Failed to add application',
                            position: 'bottom-right'
                        });
                    });
            },

            closeDrawer() {
                this.$store.commit('SET_ACTIVE_APPLICATION', {
                    value: false,
                    application: {}
                });
            }
        }
    }
</script>

<template>
    <div class="">

        <el-drawer
            title="Edit Application"
            :visible.sync="editApplicationModal"
            custom-class="demo-drawer"
            size="40%"
            ref="drawer"
        >
            <div class="drawer-area">

                <div class="drawer-body">

                    <div class="row lite-form">

                        <div class="col-md-12">
                            <br>
                            <label for="" class="input-title">Name</label>
                            <el-input v-model="form.name" placeholder="i.e Emalify Website"/>
                        </div>

                    </div>

                    <div class="row lite-form">
                        <div class="col-md-12">
                            <label for="" class="input-title">Host Name</label>
                            <el-input v-model="form.hostname" placeholder="i.e emalify.com"/>
                        </div>
                    </div>

                    <div class="row lite-form">
                        <div class="col-md-12">
                            <label for="" class="input-title">Customer Account</label>
                            <el-input v-model="form.customer_account" placeholder="Enter unique customer account here"/>
                        </div>
                    </div>


                    <div class="row lite-form">
                        <div class="col-md-12">
                            <label for="" class="input-title">Pick a background color</label>
                            <br>
                            <el-color-picker v-model="form.color"/>
                        </div>
                    </div>
                </div>

                <div class="drawer-actions">
                    <div class="row">
                        <div class="col-md-12">

                            <el-button
                                type="success"
                                size="small"
                                @click="submit">
                                <i class="el-icon-loading" v-if="submitting"/>
                                Submit
                            </el-button>

                            <el-button
                                type="info"
                                size="small"
                                @click="closeDrawer">
                                Cancel
                            </el-button>
                        </div>
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<style scoped lang="scss">
    .lite-form {
        padding: 10px !important;
    }
</style>
